var BORDER_NORM = "#d9d9d9";
var BORDER_NOW = "#382eff";
var COLOR_NORM = "#1b1b1b";
var COLOR_SET = "#b1090c";

function DatePicker (id, inputField){
	this.id = id;
    this.inputField = inputField ? ge(inputField) : text('ed-text');
    this.inputField.size = 16;
    this.callbackFunction = null;
    this.disabled = false;

    this.inputField.onclick = this.clicked.bind(this);

	this.pickerView = UI.div(
		'datePicker drop-down',
		[
			this.prevBtn = UI.span('prevBtn','<',{
				'click':this.clickPrev.bind(this),
				'mousedown': event => event.preventDefault()
			}),
			this.titleView = UI.span('titleView','title',{
				'click':this.expand.bind(this),
				'mousedown': event => event.preventDefault()
			}),
			this.nextBtn = UI.span('nextBtn','>',{
				'click':this.clickNext.bind(this),
				'mousedown': event => event.preventDefault()
			}),
			this.grid = UI.div('grid'),
			UI.div(null, [
				UI.span('todayBtn', _("Today"), {
					'click': this.gotoToday.bind(this)
				})
			])
		]
	);

    this.dropdown = Dialog.Popup(this.pickerView).sticky();
    this.hideOnSelect = false;

	this.yearGrid = UI.div('yearGrid');
	this.monthGrid = UI.div('monthGrid');
	this.dayGrid = UI.div('dayGrid');
	this.grid.appendChild(this.dayGrid);
	this.years = [];
	this.months = [];
	this.days = [];
	var i, row;
	for (i = 0; i<12;i++){
		if (i%4 === 0) {
			row = UI.div();
			this.yearGrid.appendChild(row);
		}
		row.appendChild(this.years[i] = span('pickerYear',null,
			{'click':this.selectYear.bind(this,i)}));
	}
	for (i = 0; i<12;i++){
		if (i%4 === 0) {
			row = UI.div();
			this.monthGrid.appendChild(row);
		}
		row.appendChild(this.months[i] = span('pickerMonth',null,
			{'click':this.selectMonth.bind(this,i)}));
	}
	for (i=1;i<=7;i++){
		this.dayGrid.appendChild(span('pickerWeekday',App.WD[i%7]));
	}
	for (i=0;i<42;i++){
		if (i%7 === 0) {
			row = UI.div();
			this.dayGrid.appendChild(row);
		}
		row.appendChild(this.days[i] = span('pickerDay',null,
			{'click':this.selectDay.bind(this,i)}));
	}
	this.level = 1;
	// level 1 = day grid
	// level 2 = month grid
	// level 3 = year grid
	this.weekdayOffset = 0;
	this.yearZ = null;
    this.setY = this.dispY = null;
    this.setM = this.dispM = null;
    this.setD = this.dispD = null;
    this.nowY = this.nowM = this.nowD = null;


	//onEv(this.inputField,'blur',this.setDateFromDisplay.bind(this));
	onEv(this.inputField, 'keydown',this.filterInput.bind(this));
	onEv(this.inputField, 'keyup', (
		function(ev){
			if(ev.keyCode === 13) this.setDateFromDisplay();
		}).bind(this)
	);

    this.setDate();

	this.showDays();
}
DatePicker.prototype = {
	gotoToday: function() {
		// set today as the set date
		this.setY = this.dispY = this.nowY;
		this.setM = this.dispM = this.nowM;
		this.setD = this.dispD = this.nowD;
		this.action();
	},
    setDisabled: function(disabled){
        this.disabled = disabled;
        this.inputField.disabled = disabled;
    },
    setHideOnSelect : function(value){
        this.hideOnSelect = value;
    },
	filterInput: function (ev) {
		
		var kc = ev.keyCode;

		var ok = [8, 46, 37, 39, 13, 27,191];
		for (var i = 0; i < ok.length; i++)
			if (kc === ok[i]) return;
		if (ev.keyCode < 48 || ev.keyCode > 57)
			ev.preventDefault();
	},
	setDesc: function(desc) {
		this.inputField.setAttribute('aria-label', desc);
	},
	getInputElem : function(){return this.inputField;},
	updateDisplay : function(){
		this.inputField.value = this.getDateStr();
	},
	setDateFromDisplay : function(){
		var split = this.inputField.value.split('/');
        this.setDate(Date.UTC(split[2].length === 2 ? '20' + split[2] : split[2], split[1] - 1, split[0]));
	},
    setCallbackFunction : function(callback, callbackObj){
		if (typeof(callbackObj) !== 'undefined') this.callbackFunction = callback.bind(callbackObj);
		else this.callbackFunction = callback;
    },
	setDate : function (utc){
        var d = new Date;
        this.nowY = d.getUTCFullYear();
        this.nowM = d.getUTCMonth();
        this.nowD = d.getUTCDate();

		if (utc)
            d.setTime(utc);

        this.setY = this.dispY = d.getUTCFullYear();
        this.setM = this.dispM = d.getUTCMonth();
        this.setD = this.dispD = d.getUTCDate();
		this.updateDisplay();
		this.showDays();
	},
	setDateFromSQL: function(timestamp) {
		var split = timestamp.split(/[- :]/);
		this.setDate(new Date(split[0], split[1]-1, split[2]).getTime());
	},
	getDateStr : function(){
		return numSuffix(this.setD) + ' / ' + App.MTH[this.setM] + ' / ' + this.setY;
	},
	getUTC : function(){
		return Date.UTC(this.setY, this.setM, this.setD);
	},
	getDate : function(){
		return new Date(this.setY, this.setM, this.setD);
	},
    clicked: function(event){
        if (this.disabled) return;
        if (typeof(this.inputField.selectionStart) === 'number'
            && this.inputField.selectionEnd
            && this.inputField.selectionEnd > this.inputField.selectionStart) {
        } else {
            this.dropdown.handle(this.inputField, event);
            this.inputField.blur();
        }
    },
	clickPrev : function(){
		switch (this.level){
			case 1: // day grid - change month
                this.dispM--;
                if (this.dispM < 0) {
                    this.dispM = 11;
                    this.dispY--;
                }
				this.showDays();
				break;
			case 2: // month grid - change year
                this.dispY--;
				this.showMonths();
				break;
			case 3: // year grid - change decade
                this.dispY -=10;
				this.showYears();
		}
	},
	clickNext : function(){
		switch (this.level){
			case 1: // day grid - change month
                this.dispM++;
                if (this.dispM > 11) {
                    this.dispM = 0;
                    this.dispY++;
                }
				this.showDays();
				break;
			case 2: // month grid - change year
                this.dispY++;
				this.showMonths();
				break;
            case 3: // year grid - change decade
                this.dispY += 10;
				this.showYears();
		}
	},
	expand : function(){
		switch (this.level){
			case 1: // day grid - show month grid
				this.showMonths();
				this.level = 2;
				break;
			case 2:
				// this.showYears();
				// this.level = 3;
				break; // month grid - show year grid
		}
	},
	selectYear : function(i){
        this.dispY = (this.yearZ + i - 1);
		this.showMonths();
	},
	selectMonth : function(i){
		//this.dt.setMonth(i);
        this.dispM = i;
		this.showDays();
	},
	selectDay : function(i){
        this.dispD = i-this.weekdayOffset;
        this.setDate(Date.UTC(this.dispY, this.dispM, this.dispD));
        this.action();
	},
	action : function(){
		// called by selecting date or today button
		this.updateDisplay();
		this.showDays();
		if (this.hideOnSelect) Dialog.click();
		if (this.callbackFunction !== null) this.callbackFunction();
	},
	showYears : function(){
		var displayYear = null;
		this.yearZ = (Math.floor(this.dispY/10)*10);
		this.titleView.innerHTML = this.yearZ + ' - ' + (this.yearZ + 9);
		for(var i=0;i<12;i++){
			displayYear = this.yearZ + i - 1;
			this.years[i].innerHTML = displayYear;
			this.years[i].style.color = displayYear === this.dispY ? COLOR_SET : COLOR_NORM;
			this.years[i].style.borderColor = displayYear === this.nowY	? BORDER_NOW : BORDER_NORM;
		}
		if (this.level !== 3){
			this.grid.replaceChild(this.yearGrid,this.grid.firstChild);
		}
		this.level = 3;
	},
	showMonths : function(){
		this.titleView.innerHTML = this.dispY;
		for(var i=0;i<12;i++){
			this.months[i].innerHTML = App.MTH[i];
			this.months[i].style.color = i === this.setM && this.dispY === this.setY ? COLOR_SET : COLOR_NORM;
			this.months[i].style.borderColor = i === this.nowM && this.dispY === this.nowY ? BORDER_NOW : BORDER_NORM;
		}
		if (this.level !== 2){
			this.grid.replaceChild(this.monthGrid,this.grid.firstChild);
		}
		this.level = 2;
	},
	showDays : function(){
		// determine the weekday of 1st of month & offset by that many days
		this.titleView.innerHTML = App.MONTH[this.dispM] + ' ' + this.dispY;
		var d = new Date(this.dispY, this.dispM, 1);
		this.weekdayOffset = d.getDay() - 2;
		var ditm = daysInMonth(this.dispY, this.dispM);
		d.setUTCDate(d.getUTCDate() - 1);
		var dipm = daysInMonth(d.getUTCFullYear(),d.getUTCMonth());
		var dayHeight = (this.weekdayOffset + ditm > 27) ? (this.weekdayOffset + ditm > 34) ? 24 : 30 : 36;
		var displayDay = null;
		for (var i=0;i<42;i++){
			if (i<=this.weekdayOffset) {
				this.days[i].innerHTML = (dipm - this.weekdayOffset + i);
				this.days[i].style.color = '#aaa';
			}
			else if (i - this.weekdayOffset > ditm) {
				this.days[i].innerHTML = (i - this.weekdayOffset - ditm);
				this.days[i].style.color = '#aaa';
			}
			else {
				displayDay = i - this.weekdayOffset;
				this.days[i].innerHTML = displayDay;
				this.days[i].style.color =
					displayDay === this.setD && this.dispM === this.setM && this.dispY === this.setY ?
					COLOR_SET : COLOR_NORM;
				this.days[i].style.borderColor =
					displayDay === this.nowD && this.dispM === this.nowM && this.dispY === this.nowY ?
					BORDER_NOW : BORDER_NORM;
			}
			// this.days[i].style.height = dayHeight + 'px';
		}
		if (this.level !== 1){
			this.grid.replaceChild(this.dayGrid,this.grid.firstChild);
		}
		this.level = 1;
	}
};